<template>

  <v-dialog v-model="visible" max-width="500px">
    <v-card>
      <v-card-title class="headline">検索</v-card-title>
      <v-card-text>
        <v-text-field v-model="searchQuery" clearable label="検索語を入力してください" outlined />
      </v-card-text>
      <v-card-actions>

        <v-btn color="blue" @click="emitSearchQuery">検索</v-btn>

        <v-btn color="green" @click="closeDialog">閉じる</v-btn>
      </v-card-actions>
    </v-card>
    <CardSideBar>:localProperties="localProperties"</CardSideBar>
  </v-dialog>
</template>

<script>
import CardSideBar from "./CardSideBar.vue";
export default {
  components: { CardSideBar },
  mounted() { },
  props: {
    value: {
      // v-model 用のバインディング
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      responseData: [],
      localProperties: [],
      searchQuery: "", // ダイアログ内の検索語
      authUserId: localStorage.getItem("authUserId"),
      sessionKey: localStorage.getItem("sessionKey"),
      // authInfo: {
      //   authUserId: 2, // ユーザーID（実際の値を設定してください）
      //   sessionKey: "sessionKey", // セッションキー（実際の値を設定してください）
      // },
      tableId: null, // 対象のテーブルID（実際のIDに変更してください）
      filterList: [],
      sort: {
        propertyId: null, // カラム番号（実際のIDに変更してください）
        propertyType: "", // カラムタイプ
        sortOrder: "", // ソート順（'asc' または 'desc'）
      },
    };
  },
  computed: {
    visible: {
      get() {
        return this.value; // 親から渡された value をそのまま返す
      },
      set(val) {
        this.$emit("update:modelValue", val); // ダイアログの状態を親に通知
      },
    },
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.searchQuery = "";
      }
    }
  },
  methods: {
    emitSearchQuery() {
      // このメソッドを追加
      this.$emit("update-search-query", this.searchQuery);
      this.closeDialog();
    },
    getProperties(newProperties) {
      this.localProperties = newProperties;
      console.log("プロパティ情報が更新されました:", this.localProperties);
    },
    closeDialog() {
      this.visible = false; // v-model にバインディングされている value を false にして親に通知
      this.searchQuery = null;
    },
  },
};
</script>


<style scoped>
/* ダイアログのスタイル */
.v-dialog {
  background-color: rgba(0, 0, 0, 0.5);
  /* 背景に半透明の暗い色を追加 */
}

.v-card {
  border-radius: 8px;
  /* カードに丸みをつける */
  overflow: hidden;
  /* コンテンツがカード内に収まるようにする */
}

/* カードタイトル */
.v-card-title {
  background-color: #1976d2;
  /* タイトル部分の背景色 */
  color: white;
  /* タイトルの文字色 */
  font-weight: bold;
  /* 太文字にする */
  font-size: 18px;
  /* フォントサイズを大きく */
  padding: 16px;
  /* パディングを調整 */
  text-align: center;
  /* 中央揃え */
}

/* テキストフィールド */
.v-text-field {
  margin-bottom: 16px;
  /* テキストフィールドとボタンの間にスペースを追加 */
  width: 100%;
  /* テキストフィールドがカード内で横幅いっぱいに広がる */
}

/* アクションボタン */
.v-card-actions {
  padding: 16px;
  justify-content: space-between;
  /* ボタンを左右に配置 */
}

/* 検索ボタン */
.v-btn[color="blue"] {
  background-color: #1976d2;
  /* 青いボタン */
  color: white;
  /* 文字色 */
  font-weight: bold;
  /* 太文字 */
  text-transform: uppercase;
  /* 文字を大文字に */
  padding: 10px 20px;
  /* パディングを調整 */
  border-radius: 4px;
  /* ボタンの角を丸く */
}

.v-btn[color="blue"]:hover {
  background-color: #1565c0;
  /* ホバー時の色変更 */
}

/* 閉じるボタン */
.v-btn[color="green"] {
  background-color: #388e3c;
  /* 緑色のボタン */
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  padding: 10px 20px;
  border-radius: 4px;
}

.v-btn[color="green"]:hover {
  background-color: #2c6a2f;
  /* ホバー時の色変更 */
}

/* ダイアログが開いたときのアニメーション */
.v-dialog .v-card {
  animation: fadeIn 0.3s ease-out;
}

/* フェードインのアニメーション */
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
